module.exports = __webpack_public_path__ + "img/1.393dc6df.png";